import React from 'react';
import { motion } from 'framer-motion';
import { ProductMockup } from './illustrations/ProductMockup';
import { CheckCircle2 } from 'lucide-react';
export function Hero() {
  const scrollToIncludes = () => {
    document.getElementById('que-incluye')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-pastel-blueLight/30" data-id="element-59">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-60">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-61">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col gap-6 text-center lg:text-left z-10" data-id="element-62">
            <div className="inline-flex items-center justify-center lg:justify-start gap-2 text-pastel-coral font-bold tracking-wider text-sm uppercase" data-id="element-63">
              <span className="w-8 h-0.5 bg-pastel-coral rounded-full" data-id="element-64"></span>
              Para niños de 3 a 10 años
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-slate-800" data-id="element-65">
              ✏️ Método{' '}
              <span className="text-pastel-lilac drop-shadow-sm" data-id="element-66">
                Escribo Jugando
              </span>
            </h1>

            <p className="text-xl md:text-2xl font-medium text-slate-600 leading-relaxed" data-id="element-67">
              Ayuda a tu hijo a mejorar su escritura, concentración y motricidad
              fina mientras aprende jugando.
            </p>

            <p className="text-lg text-slate-500" data-id="element-68">
              Un sistema completo con actividades, juegos y ejercicios. Ideal
              para mamás y docentes que buscan enseñar de forma simple,
              divertida y efectiva.
            </p>

            {/* Badges */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-3 mt-2" data-id="element-69">
              {['5 Módulos', '6 Bonus', '3 Plus', 'Plantillas Imprimibles Incluidas'].map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white rounded-full text-sm font-semibold text-slate-700 shadow-sm border border-slate-100" data-id="element-70">
                  <CheckCircle2 className="w-4 h-4 text-pastel-mint" data-id="element-71" />
                  {badge}
                </span>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center gap-4 mt-6" data-id="element-72">
              <div className="flex flex-col items-center w-full sm:w-auto" data-id="element-73">
                <motion.a href="https://checkout.complementodigital.shop/cart/40783303901313:1" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="w-full sm:w-auto px-8 py-4 bg-pastel-yellow hover:bg-[#FDE073] text-slate-800 font-bold text-xl rounded-2xl shadow-lg transition-colors flex items-center justify-center gap-2" data-id="element-74">
                  🔥 SOLO POR HOY $24.990
                </motion.a>
                <span className="text-sm text-slate-400 mt-2 line-through font-medium" data-id="element-75">
                  Antes $49.990
                </span>
              </div>

              <button onClick={scrollToIncludes} className="w-full sm:w-auto px-8 py-4 bg-white hover:bg-slate-50 text-slate-600 font-bold text-lg rounded-2xl shadow-sm border border-slate-200 transition-colors" data-id="element-76">
                Ver Todo Lo Que Incluye
              </button>
            </div>
          </motion.div>

          {/* Image/Mockup */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative lg:h-[600px] flex items-center justify-center" data-id="element-77">
            <ProductMockup data-id="element-78" />
          </motion.div>
        </div>
      </div>
    </section>;
}